<template>
    <div>
        <!-- <div v-for="(list, index) in statusType" :key="index"> -->
        <span class="status-view" :class="statusClass">
            <i :class="statusIcon"></i> <span>{{ statusLabel }}</span>
        </span>
        <!-- </div> -->
    </div>
</template>

<script>
export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        statusType: {
            type: String,
            default: null,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        statusIcon() {
            if (this.statusType == 'archived') {
                return 'icon-lock_outline'
            }
            if (this.statusType == 'active') {
                return 'icon-check'
            }
            if (this.statusType == 'inactive') {
                return 'icon-sign-out'
            }
            if (this.statusType == 'notfound') {
                return 'icon-check'
            }
            if (
                this.statusType == 'locked' ||
                this.statusType == 'disabled' ||
                this.statusType == 'not-applicable'
            ) {
                return 'icon-change-password'
            }
            if (
                this.statusType == 'pending' ||
                this.statusType == 'potential' ||
                this.statusType == 'processing'
            ) {
                return 'icon-loading'
            }
            if (this.statusType == 'high') {
                return 'icon-high-risk'
            }
            if (this.statusType == 'low') {
                return 'icon-low-risk'
            }
            if (this.statusType == 'medium') {
                return 'icon-medium-risk'
            }
            if (this.statusType == 'sanction') {
                return 'icon-sanction'
            }
            if (
                this.statusType == 'approved' ||
                this.statusType == 'Submitted' ||
                this.statusType == 'matched' ||
                this.statusType == 'completed' ||
                this.statusType == 'AI-hit' 
            ) {
                return 'icon-check'
            }
            if (
                this.statusType == 'hit' ||
                this.statusType == 'notmatched' ||
                this.statusType == 'found' ||
                this.statusType == 'AI-non-hit' 
            ) {
                return 'icon-wrong'
            }
            if (this.statusType == '') {
                return 'icon-check'
            }
            if (this.statusType == 'return-alert') {
                return 'icon-wrong'
            }
            if (this.statusType == 'in-active') {
                return 'icon-wrong'
            }
            return 'icon-wrong'
        },
        statusClass() {
            if (this.statusType == 'active') {
                return 'approved'
            }
            if (this.statusType == 'inactive') {
                return 'inactive'
            }
            if (this.statusType == 'locked') {
                return 'locked'
            }
            if (
                this.statusType == 'disabled' ||
                this.statusType == 'not-applicable'
            ) {
                return 'disabled'
            }
            if (
                this.statusType == 'pending' ||
                this.statusType == 'potential'
            ) {
                return 'pending'
            }

            if (this.statusType == 'high') {
                return 'high-risk'
            }
            if (this.statusType == 'low') {
                return 'low-risk'
            }
            if (this.statusType == 'medium') {
                return 'medium-risk'
            }
            if (this.statusType == 'sanction') {
                return 'sanctioned-risk'
            }
            if (
                this.statusType == 'approved' ||
                this.statusType == 'Submitted' ||
                this.statusType == 'matched' ||
                this.statusType == 'notfound' ||
                this.statusType == 'completed'
            ) {
                return 'approved'
            }
            if (this.statusType == 'hit' || this.statusType == 'notmatched' || this.statusType == "AI-non-hit") {
                return 'high-risk'
            }
            if (this.statusType == '') {
                return 'low-risk'
            }
            if (this.statusType == 'AI-hit') {
                return 'low-risk'
            }
            if (this.statusType == 'return-alert') {
                return 'rejected'
            }
            if (this.statusType == 'expired') {
                return 'rejected'
            }
            if (this.statusType == 'processing') {
                return 'processing'
            }
            if (this.statusType == 'in-active') {
                return 'rejected'
            }
            return 'rejected'
        },
        statusLabel() {
            if (this.statusType == 'completed') {
                return 'Completed'
            }
            if (this.statusType == 'active') {
                return 'Active'
            }
            if (this.statusType == 'inactive') {
                return 'Inactive'
            }
            if (this.statusType == 'locked') {
                return 'Locked'
            }
            if (this.statusType == 'not-applicable') {
                return 'Not Applicable'
            }
            if (this.statusType == 'disabled') {
                return 'Disabled'
            }
            if (this.statusType == 'pending') {
                return 'Pending'
            }
            if (this.statusType == 'processing') {
                return 'Processing'
            }
            if (this.statusType == 'archived') {
                return 'Archived'
            }
            if (this.statusType == 'potential') {
                return 'Potential'
            }
            if (this.statusType == 'high') {
                return 'High Risk'
            }
            if (this.statusType == 'low') {
                return 'Low Risk'
            }
            if (this.statusType == 'medium') {
                return 'Medium Risk'
            }
            if (this.statusType == 'sanction') {
                return 'Sanctioned'
            }
            if (this.statusType == 'approved') {
                return 'Approved'
            }
            if (this.statusType == 'Submitted') {
                return 'Submitted'
            }
            if (this.statusType == 'matched') {
                return 'Matched'
            }
            if (this.statusType == 'notmatched') {
                return 'Not Matched'
            }
            if (this.statusType == 'notfound') {
                return 'Not Found'
            }
            if (this.statusType == 'found') {
                return 'Record Found'
            }
            if (this.statusType == 'rejected') {
                return 'Rejected'
            }
            if (this.statusType == 'expired') {
                return 'Expired'
            }
            if (this.statusType == ''|| this.statusType == "AI-hit") {
                return 'No Hit'
            }
            if (this.statusType == 'hit'|| this.statusType == "AI-non-hit") {
                return 'Hit'
            }
            if (this.statusType == 'return-alert') {
                return 'Returned'
            }
            if (this.statusType == 'in-active') {
                return 'In-Active'
            }

            return this.statusType
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
